._1b9mfml0 {
  display: flex;
  flex-direction: column;
}
._1b9mfml1 {
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: var(--_1yawq2xr);
}
._1b9mfml2 {
  display: block;
  padding: var(--_1yawq2xt);
  cursor: default;
  border-radius: var(--_1yawq2x1r);
  color: var(--_1yawq2x6b);
  font-size: var(--_1yawq2x6);
  text-decoration: none;
}
._1b9mfml2:hover:not([data-disabled="true"]) {
  background: var(--_1yawq2x6i);
}
._1b9mfml2[data-disabled="true"] {
  color: var(--_1yawq2x6c);
  cursor: not-allowed;
}